"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerViewsHTML = exports.customerViewsJS = void 0;
exports.customerViewsJS = {
    "esb": require("./esb/esb"),
    "esb2": require("./esb2/esb2"),
    "esb3": require("./esb3/esb3"),
    "esb4": require("./esb4/esb4")
};
exports.customerViewsHTML = {
    "esb": require("./EsbBase/esb.tmpl.htm"),
    "esb2": require("./EsbBase/esb.tmpl.htm"),
    "esb3": require("./EsbBase/esb.tmpl.htm"),
    "esb4": require("./EsbBase/esb.tmpl.htm")
};
